import keyMirror from 'keymirror';

const ModalNames = keyMirror({
  SendTextMessageModal: null,
  SupportModal: null,
  UrgentSupportModal: null,
});

export default ModalNames;
